var React = require('react');

function ConfettiImg4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.87858 0.240067L7.79712 9.32324L0.155794 2.91861L8.87858 0.240067Z","fill":"#FF553C"}));
}

ConfettiImg4.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = ConfettiImg4;

ConfettiImg4.default = ConfettiImg4;
